import LanguageSelect from "components/molecules/LanguageSelect";
import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { useCatalogsStore } from "stores/catalogs";
import { getLocalStorageItem } from "utils/localStorage";
import { useLocalizationStore } from "stores/localization";

type LanguageSelectContainerTypes = {
  isShort?: boolean;
  onClick?: () => void;
};

const LanguageSelectContainer = (props: LanguageSelectContainerTypes) => {
  const { isShort = false, onClick } = props;

  const languages = useCatalogsStore((s) => s.languages);
  const lang = useLocalizationStore((s) => s.language);
  const selectedLanguage = (
    lang ||
    getLocalStorageItem(STORAGE_LANGUAGE_NAME) ||
    "en"
  ).toLowerCase();

  if (!languages || languages.length === 0) {
    return null;
  }

  const language =
    languages.find((l) => l.isoCode.toLowerCase() === selectedLanguage) ||
    languages[0];

  return (
    // eslint-disable-next-line react/jsx-handler-names
    <LanguageSelect language={language} isShort={isShort} onClick={onClick} />
  );
};

export default LanguageSelectContainer;
